'use strict';

import React from 'react';

import { NavLink } from 'react-router-dom'
import FaBars from 'react-icons/lib/fa/bars'
import FaClose from 'react-icons/lib/fa/close'
import NewsSectionComponent from './NewsSectionComponent.js'
import ContactFormComponent from './ContactFormComponent.js'
require('styles//Menu.css');

class MenuComponent extends React.Component {
  constructor(props) {
    super(props);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.state = {
      menuVisible: false
    }
  }

  toggleMenu() {
    this.setState({
      menuVisible: !this.state.menuVisible
    });
  }

  closeMenu() {
    this.setState({
      menuVisible: false
    });
  }

  render() {
    return (
      <nav className="menu-component">
        <NewsSectionComponent />

        <div className={this.state.menuVisible ? 'navigation-links visible' : 'navigation-links' }>
          <NavLink activeClassName='active' onClick={this.closeMenu} to='/' exact>Início</NavLink>
          <NavLink activeClassName='active' onClick={this.closeMenu} to='/quem-somos'>Quem Somos</NavLink>
          <NavLink activeClassName='active' onClick={this.closeMenu} to='/solucoesamedida'>Soluções à Medida</NavLink>
          <NavLink activeClassName='active' onClick={this.closeMenu} to='/downloads'>Downloads</NavLink>
          <NavLink activeClassName='active' onClick={this.closeMenu} to='/gestao'>Gestão</NavLink>
        </div>
        <button className="menu-toggle-button" onClick={this.toggleMenu}>
          {this.state.menuVisible && <FaClose />}
          {!this.state.menuVisible && <FaBars />}
          Menu
        </button>
        <ContactFormComponent />
      </nav>
    );
  }
}

MenuComponent.displayName = 'MenuComponent';

// Uncomment properties you need
// MenuComponent.propTypes = {};
// MenuComponent.defaultProps = {};

export default MenuComponent;



// WEBPACK FOOTER //
// ./src/components/MenuComponent.js